import { SET_SELECTED } from './types'

const setSelected = payload => ({ type: SET_SELECTED, payload })

export { setSelected }
